module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.4d3ab24.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/font/roboto/Roboto-Regular.otf
// module id = Pqgz
// module chunks = 0